import React, { CSSProperties, ReactNode } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { useUnInheritLibrariesMutation } from '../../../generated/graphql';
import styles from './UnInheritLibraryDialog.module.css';

type UnInheritLibraryDialogProps = {
    libraryId: string,
    ids: string[],
    onClose: () => void,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const UnInheritLibraryDialog = (props: UnInheritLibraryDialogProps) => {
    const { style, visible, libraryId, ids, onClose } = props;
    const [unInheritLibraries, unInheritLibrariesResult] = useUnInheritLibrariesMutation({
        variables: {
            id: libraryId,
            ids: ids
        }
    });

    const handleOnYesClick = () => {
        unInheritLibraries()
            .then(() => onClose())
            .catch(() => {});
    };

    return (
        <DialogBase
            title="Remove Source Libraries"
            type="Custom"
            isLoading={unInheritLibrariesResult.loading}
            visible={visible}
            onClose={onClose}
            className={styles.UnInheritLibraryDialog}
            style={style}
            actions={
                <>
                    <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
                    <button className="btn btn-danger" onClick={handleOnYesClick}>Remove</button>
                </>
            }
            data-testid="UnInheritLibraryDialog">
            <p style={{ color: 'var(--text-secondary)' }}>
                Are you sure you want to remove {ids.length === 1 ? 'this source library' : `these ${ids.length} source libraries`}? Registered content will be unaffected.
            </p>
        </DialogBase>
    );
};

export default UnInheritLibraryDialog;